import React, { useState, useEffect, useContext, createContext } from 'react';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import NavigationBar from "../components/Navigation";
import Footer from "../components/Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCameraRetro } from '@fortawesome/free-solid-svg-icons';
import CircularNicknameSvg from '../components/CircularNicknameSvg';
import MobileCircularNicknameSvg from '../components/MobileCircularNicknameSvg';
import { doc, updateDoc, getDoc, collection, getDocs, getFirestore } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { UserContext } from '../UserContext';
import { defaultBannerUrl, defaultAvatarUrl, defaultUsername } from '../constants';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import styles from '../styles/components/profilMember.scss'; // Assurez-vous que ce chemin est correct
import YouTube from "react-youtube";
import { Link } from "react-router-dom";
import { auth, db, storage } from '../config/firebasedeconfig.js';
import PreviewMyFavoritesMovies from "../components/PreviewMyFavoritesMovies";
import MyFavoritesActors from "../components/MyFavoritesActors";
import My3FavoriteCategories from "../components/My3FavoriteCategories";
import { mapZodiacValueToImageUrl } from '../components/valueToDisplayMappings.js';
import { Country, State } from 'country-state-city';
import { RefreshContext } from '../components/RefreshContext';
import EditTransition from '../components/EditTransition';
import UseWindowSize from '../components/UseWindowSize';
import { Helmet } from "react-helmet-async"; // Ajout pour les balises SEO
import BackToTopButton from '../components/BackToTopButton';
import { useLanguage } from '../contexts/LanguageContext.js';
import UserXpAvatar from "../components/UserXpAvatar";
import MovieReviewsCarousel from "../components/MovieReviewsCarousel";
import {
    getDisplayActivityScore,
    getLevelTitle,
    getUserActivityScore,
} from "../components/levelUtils.js";
import { getMembershipState } from "../utils/membershipUtils";

// import OnlineUsersProvider  from '../OnlineUsersContext';
const PROFILE_ACTIVITY_GAINS_STORAGE_KEY = "movieFrenzy.profileActivityGains";
const ProfilMember = () => {
    const { t, currentLanguage } = useLanguage();

    const urlParams = new URLSearchParams(window.location.search);
    const showAnimationFromUrl = urlParams.get("showAnimation") === "true";
    const [showAnimation, setShowAnimation] = useState(showAnimationFromUrl);
    const [profileActivityGains, setProfileActivityGains] = useState([]);

    useEffect(() => {
        if (!showAnimationFromUrl) return;

        try {
            const rawGains = window.sessionStorage.getItem(
                PROFILE_ACTIVITY_GAINS_STORAGE_KEY
            );

            if (!rawGains) return;

            const parsedGains = JSON.parse(rawGains);

            if (Array.isArray(parsedGains)) {
                setProfileActivityGains(parsedGains);
            }

            window.sessionStorage.removeItem(PROFILE_ACTIVITY_GAINS_STORAGE_KEY);
        } catch (error) {
            console.warn(
                "[MovieFrenzy] Impossible de lire les gains d'activité du profil :",
                error
            );
        }
    }, [showAnimationFromUrl]);

    const [forceRender, setForceRender] = useState(0);
    const { width, height } = UseWindowSize();
    const isMobile = window.innerWidth <= 768;
    const [isMobileOther, setIsMobileOther] = useState(window.innerWidth >= 769);

    let videoOpts;

    if (width <= 320) { // Galaxy S9+
        videoOpts = {
            height: '107px',
            width: '228px',
        };
    } else if (width <= 360) {
        videoOpts = {
            height: '122.75px',      // Augmenté pour iPhone X
            width: '252.5px',
        };
    } else if (width <= 375) { // iPhone X
        videoOpts = {
            height: '122px',      // Augmenté pour iPhone X
            width: '270.5px',
        };
    } else if (width <= 384) { // iPhone X
        videoOpts = {
            height: '122px',      // Augmenté pour iPhone X
            width: '272.75.5px',
        };
    } else if (width <= 390) { // iPhone 12 Pro
        videoOpts = {
            height: '128.5px',
            width: '285.25px',
        };
    } else if (width <= 396) { // iPhone 16
        videoOpts = {
            height: '128.5px',
            width: '279px',
        };
    } else if (width <= 412) { // Pixel 7
        videoOpts = {
            height: '132px',
            width: '293px',
        };
    } else if (width <= 430) { // iPhone 14 Pro Max
        videoOpts = {
            height: '134.5px',
            width: '305.25px',
        };
    } else if (width <= 432) { // iPhone 16 Plus
        videoOpts = {
            height: '141.5px',
            width: '305.75px',
        };
    } else if (width <= 480) { // iPhone 16 Plus
        videoOpts = {
            height: '160.5px',
            width: '344.75px',
        };
    } else if (width <= 320) { // Galaxy S9+
        videoOpts = {
            height: '107px',
            width: '228px',
        };
    } else {
        videoOpts = {
            height: '308.75px',
            width: '765px',
        };
    }

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    useEffect(() => {
        if (showAnimation) {
            const timer = setTimeout(() => {
                setZIndex(1); // Optionnel : si vous souhaitez toujours modifier le z-index pendant l'animation
                setShowAnimation(false); // Désactive le rendu du composant d'animation
                const newUrl = window.location.href.replace("?showAnimation=true", "");
                window.history.replaceState({}, "", newUrl);
            }, 6000);
            return () => clearTimeout(timer);
        }
    }, [showAnimation]);


    const history = useNavigate();
    // const { db } = useParams();

    const { userId } = useContext(UserContext);
    // console.log("Test avatar 09. userId est :", userId);
    const { refreshNeeded, setRefreshNeeded } = useContext(RefreshContext);

    const { username, setUsername, email, setEmail, banner, setBanner, avatar, setAvatar, isLoggedIn, userIsLoggedIn } = useContext(UserContext);
    const [userData, setUserData] = useState({});
    const [videoKey, setVideoKey] = useState("");
    const [favoritePreviews, setFavoritePreviews] = useState([]);
    const [favoriteActors, setFavoriteActors] = useState([]);
    const [favoriteCategories, setFavoriteCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const zodiacImageUrl = mapZodiacValueToImageUrl(userData.zodiacSign);
    const countryName = Country.getCountryByCode(userData.country)?.name || userData.country;
    // console.log("Test102 : " + JSON.stringify(userData));
    const allStates = State.getStatesOfCountry(userData.country);
    const stateObj = allStates.find(s => s.isoCode === userData.state);
    const [zIndex, setZIndex] = useState(40000);
    const [isLoading, setIsLoading] = useState(false);
    const [imageChangeCounter, setImageChangeCounter] = useState(0);



    // console.log('stateObj:', stateObj);
    // console.log('stateObj ? stateObj.name : "Non disponible":', stateObj ? stateObj ? stateObj.name : "Non disponible" : 'stateObj is undefined');
    // console.log('userData.state:', userData.state);

    const stateName = stateObj ? stateObj.name : t('profilMember.unavailable');
    // const [showAnimation, setShowAnimation] = useState(false);
    const { showAnimParam, userId: routeUserId } = useParams();
    const [animationTriggered, setAnimationTriggered] = useState(false);




    const handleButtonEditionProfile = () => {
        history(`/EditProfilPage/${userId}`);
    };

    useEffect(() => {
        if (showAnimParam === 'true') {
            setShowAnimation(true);
        }
    }, [showAnimParam]);

    useEffect(() => {
        const fetchUserData = async () => {
            // console.log("Test 07 Avatar et Banner. Current userId: ", userId);
            if (!userId || !isLoggedIn) return;
            // Réinitialiser l'état

            try {
                const userRef = doc(db, 'users', userId);
                // console.log("Test avatar 10. db est :", userRef);
                const docSnap = await getDoc(userRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setUserData(data);
                    console.log("Signe zodiacal pour userData.zodiacSign:", data.zodiacSign); // <-- Ajoutez cette ligne ici
                    setBanner(data.banner || defaultBannerUrl);
                    setAvatar(data.avatar || defaultAvatarUrl);
                    setUsername(data.username);
                    setEmail(data.email);

                }
            } catch (error) {
                console.error("Erreur lors de la récupération des données de l'utilisateur:", error);
            }

        };

        fetchUserData();
        if (refreshNeeded) {
            setRefreshNeeded(false);
        }

    }, [isLoggedIn, userIsLoggedIn, userId, setAvatar, setBanner, setEmail, setUsername, refreshNeeded, setRefreshNeeded, db]);


    const handleBannerChange = async (e) => {
        console.log("✅ handleBannerChange appelé", {
            fileName: e.target.files[0]?.name,
            uid: userId || routeUserId
        });
        const file = e.target.files[0];
        const activeStorage = storage;
        const uid = userId || routeUserId;
        if (!uid) {
            setErrorMsg(t('profilMember.error.missingUserId'));
            return;
        }
        if (!activeStorage) {
            setErrorMsg(t('profilMember.error.storageUnavailable'));
            return;
        }
        if (!file) return;
        // Vérifications préalables
        if (!file.type.startsWith('image/')) {
            setErrorMsg(t('profilMember.error.invalidImageFile'));
            return;
        }
        if (file.size > 10 * 1024 * 1024) { // 10 Mo (règles Storage)
            setErrorMsg(t('profilMember.error.imageTooLarge10MB'));
            return;
        }

        setIsLoading(true);
        try {
            const extension = file.name.split('.').pop();
            const fileName = `${uid}_banner_${Date.now()}.${extension}`;
            const storageRef = ref(activeStorage, `banners/${fileName}`);

            await uploadBytes(storageRef, file, { contentType: file.type });
            const downloadURL = await getDownloadURL(storageRef);

            setBanner(downloadURL);
            await updateDoc(doc(db, 'users', uid), { banner: downloadURL });

            setForceRender(prev => prev + 1);
            setImageChangeCounter(prev => prev + 1);
        } catch (error) {
            console.error("Erreur upload bannière :", error);
            setErrorMsg(t('profilMember.error.bannerUpdateFailed'));
        } finally {
            setIsLoading(false);
        }
    };


    const handleAvatarChange = async (e) => {
        console.log("✅ handleAvatarChange appelé", {
            fileName: e.target.files[0]?.name,
            uid: userId || routeUserId
        });
        const file = e.target.files[0];
        const activeStorage = storage;
        const uid = userId || routeUserId;
        if (!uid) {
            setErrorMsg(t('profilMember.error.missingUserId'));
            return;
        }
        if (!activeStorage) {
            setErrorMsg(t('profilMember.error.storageUnavailable'));
            return;
        }
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            setErrorMsg(t('profilMember.error.invalidImage'));
            return;
        }
        if (file.size > 5 * 1024 * 1024) { // 5 Mo (règles Storage)
            setErrorMsg(t('profilMember.error.avatarTooLarge5MB'));
            return;
        }

        setIsLoading(true);
        try {
            const extension = file.name.split('.').pop();
            const fileName = `${uid}_avatar_${Date.now()}.${extension}`;
            const storageRef = ref(activeStorage, `avatars/${fileName}`);

            await uploadBytes(storageRef, file, { contentType: file.type });
            const downloadURL = await getDownloadURL(storageRef);

            setAvatar(downloadURL);
            await updateDoc(doc(db, 'users', uid), { avatar: downloadURL });

            setForceRender(prev => prev + 1);
            setImageChangeCounter(prev => prev + 1);
        } catch (error) {
            console.error("Erreur upload avatar :", error);
            setErrorMsg(t('profilMember.error.avatarUpdateFailed'));
        } finally {
            setIsLoading(false);
        }
    };


    const openFilePicker = (type) => {
        const id = type === 'banner'
            ? 'bannerFileInput'
            : (window.innerWidth <= 768 ? 'avatarFileInputMobile' : 'avatarFileInputSide');

        // Supprime l'input existant, s'il y en a un
        document.getElementById(id)?.remove();

        // Crée un nouvel input isolé pour forcer l'événement "change"
        const el = document.createElement('input');
        el.type = 'file';
        el.id = id;
        el.accept = 'image/*';
        el.style.display = 'none';
        el.onchange = type === 'banner' ? handleBannerChange : handleAvatarChange;

        document.body.appendChild(el);
        el.click();
    };


    useEffect(() => {
        // Ceci est déclenché à chaque changement de forceRender
        console.log("Forcing re-render");
    }, [forceRender]);



    // Ajout d'une référence pour le lecteur YouTube
    const youtubePlayerRef = React.useRef(null);

    useEffect(() => {
        let isMounted = true;
        const fetchYouTubeKey = async () => {
            if (userData.favoriteMovie && userData.favoriteMovie.id) {
                try {
                    const videoResponse = await axios.get(
                        `https://api.themoviedb.org/3/movie/${userData.favoriteMovie.id}/videos?api_key=e16900047627f56531a2d3d8d4df9e92&language=fr-FR`
                    );
                    const videoData = videoResponse.data.results.find(
                        (video) => video.site.toLowerCase() === "youtube"
                    );
                    if (videoData && isMounted) {
                        setVideoKey(videoData.key);
                    }
                } catch (error) {
                    console.error("Erreur lors de la récupération de la clé vidéo:", error);
                }
            }
        };

        fetchYouTubeKey();

        // Nettoyage: annuler les mises à jour d'état si le composant est démonté
        return () => {
            isMounted = false;
        };
    }, [userData.favoriteMovie]);

    // useEffect pour nettoyer le lecteur YouTube au démontage
    useEffect(() => {
        return () => {
            // Nettoyage du lecteur YouTube au démontage
            if (youtubePlayerRef.current && youtubePlayerRef.current.internalPlayer) {
                try {
                    youtubePlayerRef.current.internalPlayer.stopVideo();
                    youtubePlayerRef.current.internalPlayer.destroy();
                } catch (err) {
                    console.error("Erreur lors du nettoyage du lecteur YouTube:", err);
                }
            }
        };
    }, []);

    useEffect(() => {
        let isMounted = true;
        const fetchFavoritePreviews = async () => {
            if (!userId) return;
            try {
                const userRef = doc(db, 'users', userId);
                const userDoc = await getDoc(userRef);
                if (isMounted) {
                    const moviesData = userDoc.data().favoritePreviews || [];
                    setFavoritePreviews(moviesData);
                    const moviesData2 = userDoc.data().favoriteActors || [];
                    setFavoriteActors(moviesData2);
                    const moviesData3 = userDoc.data().favoriteCategories || [];
                    setFavoriteCategories(moviesData3);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des films favoris:", error);
            }
        };

        if (isLoggedIn) {
            fetchFavoritePreviews();
        }

        // Nettoyage: annuler les mises à jour d'état si le composant est démonté
        return () => {
            isMounted = false;
        };
    }, [userIsLoggedIn, refreshNeeded, setRefreshNeeded, userId, setFavoritePreviews, setFavoriteActors, setFavoriteCategories, db, isLoggedIn]);


    useEffect(() => {
        let isMounted = true;
        const fetchUpdatedUserData = async () => {
            try {
                let userRef = null;
                if (userId && db) {
                    userRef = doc(db, 'users', userId);
                } else {
                    console.error('Either userId or db is undefined', userId, db);
                }

                if (userRef) {
                    const docSnap = await getDoc(userRef);

                    if (docSnap.exists() && isMounted) {
                        setUserData(docSnap.data());
                        const { avatar, banner, username, email } = docSnap.data();
                        setBanner(banner || defaultBannerUrl);
                        setAvatar(avatar || defaultAvatarUrl);
                        setUsername(username);
                        setEmail(email);
                    }
                }
            } catch (error) {
                console.error("Erreur lors de la mise à jour des données de l'utilisateur après modification de la bannière/avatar:", error);
            }
        };

        fetchUpdatedUserData();
        if (refreshNeeded) {
            setRefreshNeeded(false);
        }

        // Nettoyage: annuler les mises à jour d'état si le composant est démonté
        return () => {
            isMounted = false;
        };
    }, [userId, db, setBanner, setAvatar, setUsername, setEmail, refreshNeeded, setRefreshNeeded]);

    useEffect(() => {
        let isMounted = true;
        const fetchFavoriteActors = async () => {
            if (!userId) return;
            try {
                const userRef = doc(db, 'users', userId);
                const userDoc = await getDoc(userRef);
                if (isMounted) {
                    const actorsData = userDoc.data().favoriteActors || [];
                    setFavoriteActors(actorsData);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des acteurs favoris:", error);
            }
        };

        if (isLoggedIn) {
            fetchFavoriteActors();
        }

        // Nettoyage: annuler les mises à jour d'état si le composant est démonté
        return () => {
            isMounted = false;
        };
    }, [userIsLoggedIn, refreshNeeded, setRefreshNeeded, userId, setFavoriteActors, db, isLoggedIn]);

    useEffect(() => {
        let isMounted = true;
        const fetchFavoriteCategories = async () => {
            if (!userId) return;
            try {
                const userRef = doc(db, 'users', userId);
                const userDoc = await getDoc(userRef);
                if (isMounted) {
                    const categoriesData = userDoc.data().favoriteCategories || [];
                    setFavoriteCategories(categoriesData);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des catégories favorites:", error);
            }
        };

        if (isLoggedIn) {
            fetchFavoriteCategories();
        }

        // Nettoyage: annuler les mises à jour d'état si le composant est démonté
        return () => {
            isMounted = false;
        };
    }, [userIsLoggedIn, refreshNeeded, setRefreshNeeded, userId, setFavoriteCategories, db, isLoggedIn]);

    //cIndex with delay
    useEffect(() => {
        // Set a timer to change zIndex after 6 seconds
        const timerId = setTimeout(() => {
            setZIndex(1);  // Change zIndex to 1
        }, 6000);  // 6 seconds

        // Cleanup function to clear the timer if the component unmounts
        return () => {
            clearTimeout(timerId);
        };
    }, []);

    // Redirection seulement après que Firebase ait déterminé l'état d'authentification
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) {
                console.warn("Utilisateur non connecté (ou session expirée). Redirection vers Connexion.");
                history("/connexion");
            }
        });
        return () => unsubscribe();
    }, [history]);


    // console.log("userData.country:", userData.country);
    // console.log("userData.state:", userData.state);

    const displayName = isLoggedIn ? username : t('profilMember.unknownUser');
    const subscription = userData?.subscription;

    const {
        effectiveTier: profileEffectiveTier,
        hasPaidAccess: profileHasPaidAccess,
    } = getMembershipState(subscription);

    const planLabel =
        profileEffectiveTier === "cinephile"
            ? t("navigation.subscriptionStatus.cinephile")
            : profileEffectiveTier === "fanatic"
                ? t("navigation.subscriptionStatus.fanatic")
                : t("navigation.subscriptionStatus.free");

    const subscriptionStatusLabel =
        profileHasPaidAccess
            ? t("navigation.subscriptionStatus.active")
            : profileEffectiveTier === "free"
                ? ""
                : t("navigation.subscriptionStatus.inactive");

    const profileActivityScore = getUserActivityScore(
        userData,
        userData?.messageCount ?? 0
    );

    const profileEffectiveScore = getDisplayActivityScore(profileActivityScore, userId);

    const profileActivityLabel = Number.isInteger(profileEffectiveScore)
        ? String(profileEffectiveScore)
        : profileEffectiveScore.toFixed(2).replace(/\.?0+$/, "");

    const mobileLevelKey = getLevelTitle(profileEffectiveScore);
    const mobileLevelTitle = t(`forum.levelTitles.${mobileLevelKey}`);

    return (
        <>

            {/* Ajout de Helmet pour le SEO */}
            <Helmet>
                <title>{t('profilMember.pageTitle', { username: displayName })}</title>
                <meta name="description" content={t('profilMember.metaDescription', { username: displayName })} />
                <link rel="canonical" href={`https://moviefrenzy.ca/profil/${userId}`} />
            </Helmet>
            <div className="profilMember"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/darkwater.jpg)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "fixed",
                    backgroundBlendMode: "overlay",
                    backgroundColor: "#200211",
                    opacity: "0.9",
                    overflowX: "hidden",
                    overflowY: "auto",
                    display: "block",
                    zIndex: "1000",
                }}
            >
                {/* <div className='pc-Container'></div> */}
                <NavigationBar />
                {showAnimation && (
                    <div
                        className="transitionContainer"
                        style={{
                            width: "100%",
                            height: "100%",
                            position: "fixed",
                            top: "0",
                            left: "0",
                            zIndex: zIndex,
                        }}
                    >
                        <EditTransition
                            isSaveClicked={true}
                            activityGains={profileActivityGains}
                        />
                    </div>
                )}
                <div className="wrapper container-fluid">
                    <div className="row rowBanner">
                        <div className="col-12 col-md-12" id='div-rowBannerForMobile'>
                            <div className="banner" style={{ backgroundImage: `url(${banner || defaultBannerUrl}?${imageChangeCounter})` }}>
                                {/* Version mobile de l'avatar et du nickname mode <UserXpAvatar /> */}
                                {/* ok change 2026-06-04-01 */}
                                <div className="profil-member-xp-avatar-mobile-shell">
                                    <div className="profil-member-xp-avatar-mobile-wrapper">
                                        <UserXpAvatar
                                            avatarUrl={avatar || defaultAvatarUrl}
                                            activityScore={profileActivityScore}
                                            fallbackActivityScore={userData?.messageCount}
                                            showTitle={false}
                                            showActivity={false}
                                            className="user-xp-avatar--profil-member-mobile"
                                            userId={userId}
                                        />

                                        <input
                                            type="file"
                                            id="avatarFileInputMobile"
                                            style={{ display: 'none' }}
                                            onChange={handleAvatarChange}
                                        />

                                        {/* <span className="avatarEditSpan" onClick={() => openFilePicker('avatar')}>
                                            <FontAwesomeIcon
                                                icon={faCameraRetro}
                                                size="lg"
                                                color="white"
                                                className="cameraRetro"
                                                style={{ transform: isMobile ? 'scale(0.5)' : 'scale(1)' }}
                                            />
                                        </span> */}
                                    </div>
                                </div>
                                <div className="divCircularNicknameMobile" style={{ visibility: isMobile ? 'visible' : 'hidden' }}>
                                    {isMobile && (
                                        <span className="profil-member-mobile-username-arc">
                                            {displayName}
                                        </span>
                                    )}
                                </div>
                                {isMobile && (
                                    <>
                                        <div className="profil-member-mobile-level-arc">
                                            {mobileLevelTitle}
                                        </div>

                                        <div className="profil-member-mobile-activity-card">
                                            <span className="profil-member-mobile-activity-card__label">
                                                {t('profilMember.activity')}
                                            </span>
                                            <span className="profil-member-mobile-activity-card__value">
                                                {profileActivityLabel}
                                            </span>
                                        </div>
                                    </>
                                )}
                                <input type="file" id="bannerFileInput" style={{ display: 'none' }} onChange={handleBannerChange} />
                                <span className="bannerEditSpan" onClick={() => openFilePicker('banner')}>
                                    <FontAwesomeIcon icon={faCameraRetro} size="lg" color="#D90093" className='cameraRetro' style={{ transform: isMobile ? 'scale(0.5)' : 'scale(1)' }} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row rowBio">
                        <div className="col-12 col-md-8 bioSection">
                            <div className="div-biseau">
                                <h2>{t('profilMember.myBiography')}</h2>
                                <span className='spanBio'>
                                    <blockquote className="citationProfil">
                                        <q>{userData.quote}</q>
                                    </blockquote>
                                    <div className='bioText' dangerouslySetInnerHTML={{ __html: userData.biography }}></div>
                                </span>
                            </div>
                        </div>
                        <div className="col-12 col-md-8 bioSection-mobile">
                            <h2 id='titreMaBio'>{t('profilMember.myBiography')}</h2>
                            <blockquote className="citationProfil">
                                <q>{userData.quote}</q>
                            </blockquote>
                            <div className='bioText' dangerouslySetInnerHTML={{ __html: userData.biography }}></div>
                        </div>
                        <div className="col-12 col-md-4 avatarSection">
                            <div className="profil-member-xp-avatar-wrapper div-circularAvatar">
                                <UserXpAvatar
                                    avatarUrl={avatar || defaultAvatarUrl}
                                    activityScore={profileActivityScore}
                                    fallbackActivityScore={userData?.messageCount}
                                    showTitle={true}
                                    showActivity={false}
                                    className="user-xp-avatar--profil-member"
                                    userId={userId}
                                />

                                <input type="file" id="avatarFileInputSide" style={{ display: 'none' }} onChange={handleAvatarChange} />
                                <span className="avatarEditSpan" onClick={() => openFilePicker('avatar')}>
                                    <FontAwesomeIcon icon={faCameraRetro} size="lg" color="#D90093" className='cameraRetroAvatar' />
                                </span>
                            </div>
                            <div className="div-circularNickname" style={{ margin: "0 0 3vh 0", paddingBottom: "-2vh" }}>
                                {!isMobile && <CircularNicknameSvg username={displayName} />}
                            </div>
                            <div className="profil-member-activity-card">
                                <span className="profil-member-activity-card__label">
                                    {t('profilMember.activity')}
                                </span>
                                <span className="profil-member-activity-card__value">
                                    {profileActivityLabel}
                                </span>
                            </div>
                            {subscription && (
                                <div className="subscription-badge">
                                    <span className="subscription-badge__plan">
                                        {planLabel}
                                    </span>

                                    {subscriptionStatusLabel && (
                                        <span className="subscription-badge__status">
                                            {subscriptionStatusLabel}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row rowIdentify">
                        <div className="col-12 col-md-4">
                            <div className="identification1" id='identification1PourBaseProfil'>
                                <h2 className='infoPersos' id='idInfoPerso'>{t('profilMember.myPersonalInfo')}</h2>
                                <div className='blocInfo'>
                                    <div className='divGender' id='divGenderId'>
                                        <span>{t('profilMember.sexGenre')}&nbsp;</span>
                                        <span className='inputGender'>
                                            {t(`gender.${userData.gender}`)}
                                        </span>
                                    </div>
                                    <div className='divAge' id='divAgeId'>
                                        <span>{t('profilMember.age')}&nbsp;</span>
                                        <span className='inputAge'>{userData.age}</span>
                                    </div>
                                    <div className='inputZodiacSignBase' id='inputZodiacSignBaseId'>
                                        <span id='span1Zodiac' style={{ display: "inline-block", marginRight: "5vw" }}>{t('profilMember.myZodiacSign')}&nbsp;</span>
                                        <figure className='inputZodiacSign'>
                                            <img src={zodiacImageUrl} alt={userData.zodiacSign} />
                                            <figcaption>{userData.zodiacSign}</figcaption>
                                        </figure>
                                    </div>
                                    <div className='divOccupation' id='divOccupationId'>
                                        <span id='span_1_OccupationId'>{t('profilMember.occupation')}&nbsp;</span>
                                        <span className='inputOccupation' id='span_2_OccupationId'>
                                            {t(`occupation.${userData.occupation}`)}
                                        </span>
                                    </div>
                                    <div className='divPays' id='divPaysId'>
                                        <span id='divPaysIdSpan1'>{t('profilMember.myCountry')}&nbsp;</span>
                                        <span className='inputPays'>{countryName}</span>
                                    </div>
                                    <div className='divEtatProvince' id='divEtatProvinceId'>
                                        <span id='divEtatProvinceIdSpan1'>{t('profilMember.myProvinceState')}&nbsp;</span>
                                        <span className='inputEtatProvince'>{String(stateName)}</span>
                                    </div>
                                    <div className='divVille' id='divVilleId'>
                                        <span id='divVilleIdSpan1'>{t('profilMember.myCity')}&nbsp;</span>
                                        <span className='inputVille'>{userData.city}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* CARROUSEL AVIS MOVIEFRENZY - ProfilMember */}
                        {/* <div className="row rowReviewsCarousel">
                            <div className="col-12">
                                <MovieReviewsCarousel
                                    userId={userId}
                                    title="Mes Avis MovieFrenzy"
                                    emptyLabel="Tu n'as pas encore publié d'avis. Partage ton premier !"
                                    autoScroll={true}
                                />
                            </div>
                        </div> */}
                        <div className="col-12 col-md-8">
                            <div className="identification2_BaseProfil">
                                <h2>{t('profilMember.myCinephileProfile')}</h2>
                                <div className='preferContainer_BaseProfil'>
                                    <h4 className='h4Prefer_BaseProfil'>{t('profilMember.myFavoriteMovies')}</h4>
                                    <div className='rowPrefer_BaseProfil' id='rowPreferFilm'>
                                        {favoritePreviews.map(movie => (
                                            <Link to={`/ficheFilm/${movie.id}`} key={movie.id} >
                                                <PreviewMyFavoritesMovies key={movie.id} movie={movie} />
                                            </Link>
                                        ))}
                                    </div>
                                    <h4 className='h4Prefer_BaseProfil'>{t('profilMember.myFavoriteActors')}</h4>
                                    <div className='rowPrefer_BaseProfil'>
                                        {favoriteActors.map(actor => (
                                            <Link to={`/actorDetails/${actor.id}`} key={actor.id}>
                                                <MyFavoritesActors key={actor.id} actor={actor} />
                                            </Link>
                                        ))}
                                    </div>
                                    <h4 className='h4Prefer_BaseProfil'>{t('profilMember.myFavoriteGenres')}</h4>
                                    <div className='rowPrefer_BaseProfil'>
                                        {favoriteCategories.map(category => (
                                            <My3FavoriteCategories key={category.id} category={category} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* CARROUSEL AVIS MOVIEFRENZY - ProfilMember */}
                    <div className="row rowReviewsCarousel">
                        <div className="col-12">
                            <MovieReviewsCarousel
                                userId={userId}
                                autoScroll={true}
                            />
                        </div>
                    </div>
                    <div className="row rowFavoritePreview">
                        <div className="col-12 col-md-6">
                            <h3 className='h3CooupCoeur'>{t('profilMember.myFavoritePreview')}</h3>
                            <div className="aspect-ratio-container">
                                {videoKey ? (
                                    <YouTube
                                        videoId={videoKey}
                                        className="iFrameStyle"
                                        id="iFrameStyleIdTest"
                                        opts={videoOpts}
                                        ref={youtubePlayerRef}
                                        onMouseEnter={() => {
                                            setIsHovered(true);
                                            setZIndex(1000);
                                        }}
                                        onMouseLeave={() => {
                                            setIsHovered(false);
                                            setZIndex(40000);
                                        }}
                                        onReady={(event) => {
                                            event.target.pauseVideo();
                                            event.target.setVolume(0);
                                        }}
                                    />
                                ) : (
                                    <p>{t('profilMember.noFavoritePreview')}</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row rowEditionProfi">
                        <div className="col-12 col-md-6">
                            <button onClick={handleButtonEditionProfile}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                className={currentLanguage === 'de' ? 'german-button-adjust' : ''}
                                style={{
                                    position: 'relative',
                                    color: isHovered ? '#FFFFFF' : '#00FFFF',
                                    backgroundImage: 'linear-gradient(to right, #D90093, #00FFFF)',
                                    backgroundSize: isHovered ? '100% 100%' : '0% 100%',
                                    border: '2px solid #D90093',
                                    borderRadius: "10px",
                                    width: '12vw',
                                    height: '7.5vh',
                                    fontSize: '1.60rem',
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    backgroundRepeat: 'no-repeat',
                                    outline: 'none',
                                    cursor: 'pointer',
                                    zIndex: 9999,
                                    overflow: 'hidden',
                                    fontWeight: 'bold',
                                    transition: '0.5s ease, color 0.5s ease',
                                    margin: '0 auto',
                                    boxShadow: '0 8px 16px rgba(217, 0, 147, 0.5)',
                                    backdropFilter: 'blur(0.5rem)',
                                    textShadow: '0 0 0.5rem rgba(0, 0, 0, 0.5)',
                                    textAlign: 'center',
                                    padding: '0.065rem',
                                }}>
                                {t('profilMember.editMyProfile')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <BackToTopButton />
            </div>
            <div className="actor-details-footer"
                style={{ maxWidth: '100%', maxHeight: '100%' }}
            >
                <Footer />
            </div>
        </>
    );
};

export default ProfilMember;

